module.exports = __webpack_public_path__ + "static/media/pendulum-dynamics.b4d2b22f.mp4";